export default "__VITE_ASSET__BJHQLB2f__"